import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MatchDetailStatRow from '../MatchDetailStatRow/MatchDetailStatRow';
import MatchDetailStatsEmpty from '../MatchDetailStatsEmpty/MatchDetailStatsEmpty';
import { getMatchesStatistics } from '../../../services/getMatchesStatistics';
import { buildStatsData } from '../../../utils';
import './_MatchDetailStats.scss';

class MatchDetailStats extends Component {
  constructor(props) {
    super(props);
    this.state = {
      statsFromApi: []
    };
    this.leagueId = props.leagueId;
    this.matchId = props.matchId;
    this._isMounted = false;
    this._statsRequestId = 0;
  }

  componentDidMount() {
    this._isMounted = true;
    // this.fetchStatsFromApi(); // Anterior, cuando hacía la llamada a la API directamente desde este componente.
    this.setState({ statsFromApi: Array.isArray(this.props.data) ? this.props.data : [] });
  }

  componentDidUpdate(prevProps, prevState) {
    const leagueChanged = prevProps.leagueId !== this.props.leagueId;
    const matchChanged = prevProps.matchId !== this.props.matchId;

    if (leagueChanged || matchChanged) {
      this.leagueId = this.props.leagueId;
      this.matchId = this.props.matchId;
      // this.fetchStatsFromApi(); // Anterior, cuando hacía la llamada a la API directamente desde este componente.
    }

    if (prevProps.data !== this.props.data) {
      this.setState({ statsFromApi: Array.isArray(this.props.data) ? this.props.data : [] });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  // fetchStatsFromApi = async () => {
  //   if (!this.leagueId || !this.matchId) return;

  //   const requestId = ++this._statsRequestId;
  //   const view = 'team-statistics';

  //   try {
  //     const matchStats = await getMatchesStatistics(this.leagueId, this.matchId, view);
  //     if (!this._isMounted || requestId !== this._statsRequestId) return;

  //     const mappedStats = buildStatsData(matchStats);
  //     this.setState({ statsFromApi: Array.isArray(mappedStats) ? mappedStats : [] });
  //   } catch (error) {
  //     if (!this._isMounted || requestId !== this._statsRequestId) return;
  //     this.setState({ statsFromApi: [] });
  //   }
  // }

  getStatsToRender = () => {
    const { stats } = this.props;
    const { statsFromApi } = this.state;
    return Array.isArray(statsFromApi) && statsFromApi.length > 0 ? statsFromApi : stats;
  }

  render() {
    const stats = this.getStatsToRender();
    const hasStats = Array.isArray(stats) && stats.length > 0;

    if (!hasStats) {
      return <MatchDetailStatsEmpty />;
    }

    return (
      <div className="match-detail-stats">
        {stats.map((item, index) => (
          <MatchDetailStatRow
            key={item.label + '-' + index}
            label={item.label}
            leftValue={item.leftValue}
            rightValue={item.rightValue}
            leftPercent={item.leftPercent}
            rightPercent={item.rightPercent}
            leftColor={item.leftColor}
            rightColor={item.rightColor}
          />
        ))}
      </div>
    );
  }
}

MatchDetailStats.propTypes = {
  stats: PropTypes.array,
  leagueId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  matchId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

MatchDetailStats.defaultProps = {
  stats: [],
  leagueId: null,
  matchId: null
};

export default MatchDetailStats;



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/FootballMatchDetail/Components/MatchDetailStats/MatchDetailStats.jsx